import { BeanActionPlanFiles } from './BeanActionPlanFiles'
import { BeanStatusPlanoAcao } from './BeanStatusPlanoAcao'
import { BeanUsuario } from './BeanUsuario'

export class BeanPlanoDeAcao{
  constructor(


    public placIdCdPlanoacao : string,
    public operIdCdOperacao : string,
    public placDsAcao : string,
    public placdsobjetivo : string,
    public placDhDataacao : string,
    public placNrPrazodiasacao : string,
    public placDsResponsavel  : string,
    public stacIdCdStatusacao : string,
    public placDsAnaliseeficacia : string,
    public placDsTracker : string,
    public placDsObservacao : string,
    public usuaIdCdUsuario : string,
    public placDhCadastro : string,
    public placDhInativo : string,
    public percentual : string,
    public datafinalacao : string,
    public statusPlanoAcao : string,
    public statusObj: BeanStatusPlanoAcao,

    public usuaIdCdUsuarioUpdate : string,
    public userUpdate: BeanUsuario,
    public placDhUpdate : string,

    public usuaIdCdUsuarioConcluiu : string,
    public userConcluiu: BeanUsuario,
    public placDhConcluido: string,
    public actionPlanFiles: BeanActionPlanFiles


  ){}
}
